import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useDeleteFavoriteList = (id: number, type: 'leave' | 'delete') => {
  async function fetchDeleteFavoriteList(url: string) {
    try {
      const data = await fetcher.delete(url);
      if (data?.error) {
        return toast.error(`Не удалось удалить список: ${data?.error}`, { autoClose: 5000 });
      }
      toast.success('Список удален', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось удалить список', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    type === 'leave' ? `/favourites/list/${id}/leave` : `/favourites/list/${id}`,
    fetchDeleteFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useDeleteFavoriteList;
